import { render } from "./SidebarMenuAction.vue?vue&type=template&id=0d2ff8d8&ts=true"
import script from "./SidebarMenuAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenuAction.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarMenuAction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d2ff8d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d2ff8d8', __exports__)) {
    api.reload('0d2ff8d8', __exports__)
  }
  
  module.hot.accept("./SidebarMenuAction.vue?vue&type=template&id=0d2ff8d8&ts=true", () => {
    api.rerender('0d2ff8d8', render)
  })

}


export default __exports__